import React from 'react';
import { DebouncedTextField } from 'components/Fields';
import FilterContainer from 'components/containers/Filter';

const StateFilters = (props) => (
	<FilterContainer {...props} variant='standard' margin='normal'>
		<DebouncedTextField source='isw_iso' label='ISO' />
		<DebouncedTextField source='isw_name' label='Name' />
	</FilterContainer>
);

export default StateFilters;